import type { I18nTranslation } from '@crehana/i18n';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export const DiplomasLocalesBundle: I18nTranslation = { es, pt, en };
